__webpack_require__.p = "https://staging.geofix.nu/";